<template>
  <component :is="ThemedComponent" v-bind="$attrs">
    <slot />
  </component>
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false })

const props = defineProps({
  path: {
    type: String,
    required: true,
  },
  componentName: {
    type: String,
    required: true,
  },
})

const themeStyleStore = useThemeStyleStore()
const ThemedComponent = computed(() => defineAsyncComponent(() => {
  return import(`~/components/Theme/${themeStyleStore.frame}/${props.path}/${props.componentName}.vue`)
}))
</script>
